module.exports = __webpack_public_path__ + "img/japan-other-heart-diseases-male.81de7548.png";